import { Box, DialogContent, IconButton, styled } from "@mui/material";

export const StyledBox = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== "modalInnerContainerStyles" && prop !== "isMobileApp",
})<{
    isMobileApp?: boolean;
    modalInnerContainerStyles?: object;
}>(({ modalInnerContainerStyles, isMobileApp = false }) => ({
    ...modalInnerContainerStyles,
    boxShadow: "rgba(0, 0, 0, 0.15) 0px -4px 10px 0px",
    background: "var(--community-color-snow-white)",
    maxHeight: "none",
    borderTop: "1px solid var(--community-color-dark-gray)",
    borderRadius: 0,
    height: "100%",
    width: "100%",
    // We need a slight delay for layout change for iOS submit button
    transition: "padding .1s",
}));

export const StyledDialogContent = styled(DialogContent, {
    shouldForwardProp: (prop) => prop !== "isPaddingVisible",
})<{ isPaddingVisible: boolean }>(({ isPaddingVisible }) => ({
    borderRadius: 0,
    height: "100%",
    padding: isPaddingVisible ? "16px" : 0,
}));

export const OutsideModalIconButton = styled(IconButton)({
    position: "absolute",
    right: 8,
    top: "-45px",
    color: "var(--community-color-primary-text)",
    backgroundColor: "rgba(255,255,255,0.6)",
});
